import React from "react";
import HeroSection from "../../components/home/slideHome";
import GroupeSection from "../../components/home/GroupeSection";
import CorporateStats from "../../components/home/CorporateStats";
import CoworkingSection from "../../components/home/CoworkingSection";
import ContactSection from "../../components/home/ContactSection";

export const HomePage = () => {
  return (
    <div>
      <HeroSection />
      <GroupeSection />
      <CorporateStats />
      <CoworkingSection />
      <ContactSection />
    </div>
  );
};
